<template>
  <q-page-container
    class="full-height"
    style="height: 100%"
  >
    <q-page class="">
      <section class="section-service col-12">
        <q-option-group
          hidden
          v-model="panel"
          inline
          :options="[{ label: 'Tab-1', value: 'tab-1' }]"
        />
        <q-tab-panels
          v-model="panel"
          class="panel-services"
        >
          <q-tab-panel
            class="panel-item"
            name="tab-1"
          >
            <q-form
              ref="formtab1"
              class="col-12 full-width"
            >
              <div class="title-page-form">Dados da solicitação</div>
              <DefaultForm
                :typeOs="typeOs"
                :requestData="schemaRequest"
                :optionsItens="optionsItens"
              />
            </q-form>
          </q-tab-panel>
        </q-tab-panels>
        <div>
          <FooterToolbar
            :progressBarValue="progressBar"
            :nextTabFn="validateForm"
            :isLoading="false"
            :isShowSubmitButton="false"
          />
        </div>
      </section>
    </q-page>
  </q-page-container>
</template>

<script>
  import FooterToolbar from "@/components/SpecialCodes/FooterToolbar.vue";
import RequiredLabel from "@/components/SpecialCodes/RequiredLabel.vue";
import moment from "moment";
import { onBeforeMount, onMounted, reactive, ref } from "vue";
import DefaultForm from "./DefaultForm.vue";

  export default {
    name: "SolicitationForm",
    components: {
      RequiredLabel,
      FooterToolbar,
      DefaultForm,
    },
    props: {
      listWriteOffCode: Array,
      listTypeOS: Array,
      itemOsContract: Object,
      typeOs: String,
      optionsItens: Object,
      city: Object,
    },
    emits: ["saveSchemaRequest", "removeEdit"],

    setup(props, { emit }) {
      moment.locale("pt-br");

      let panel = ref("tab-1");
      let progressBar = ref(0.5);

      let schemaRequest = reactive({
        object_id: "",
        osNumber: "",
        typeOS: "",
        statusOS: 1,
        observation: "",
        check: false,
      });

      const populateSchemaRequest = () => {
        return {
          ...schemaRequest,
          object_id: props.itemOsContract.data.object_id,
          osNumber: props.itemOsContract.data.osNumber,
          typeOS: props.itemOsContract.data.typeOS,
          observation: props.itemOsContract.data.observation,
        };
      };

      const formtab1 = ref(null);

      function setTypeOsByServiceOption() {
        if (props.optionsItens.optionsTypeOS.length == 1) {
          schemaRequest.typeOS = props.optionsItens.optionsTypeOS[0];
        }
      }

      async function validateSingleTabForm() {
        const isValid = await formtab1.value.validate();
        if (isValid) {
          await emitData();
        }
        return isValid;
      }

      async function validateForm() {
        return await validateSingleTabForm();
      }

      async function emitData() {
        schemaRequest.check = true;
        schemaRequest.isFilled = true;
        schemaRequest.object_id = props.itemOsContract.data.object_id;
        emit("saveSchemaRequest", schemaRequest);
      }

      const cityDetails = {
        atendimento: props.city.atendimento,
        profile: props.city.profile,
      };

      const updateSchemaRequest = () => {
        const editData = populateSchemaRequest();
        Object.assign(schemaRequest, editData);
      };

      onBeforeMount(() => {
        setTypeOsByServiceOption();
      });

      onMounted(() => {
        progressBar.value = 1;

        if (props.itemOsContract.data.isFilled) {
          updateSchemaRequest();
        }
      });

      return {
        panel,
        progressBar,
        schemaRequest,
        formtab1,
        validateForm,
        validateSingleTabForm,
        cityDetails,
      };
    },
  };
</script>

<style scoped lang="scss">
  label {
    font-family: Roboto;
    font-style: normal;
  }

  .q-page-container {
    padding-bottom: 0px !important;
  }

  .label-checkbox-confirm {
    font-weight: 500 !important;
    font-size: 12px !important;
    line-height: 14px !important;
    letter-spacing: 0.01em !important;
    color: #999999 !important;
  }

  footer {
    background: #e5e5e5 !important;
    height: 12vh;

    .q-toolbar {
      height: 12vh;
    }

    .div-progress {
      height: 8vh;
    }

    .div-btn-next {
      height: 8vh;
    }
  }

  .section-service {
    width: 100%;

    .panel-services {
      background: transparent !important;
      overflow: hidden !important;

      .title-page {
        font-weight: bold;
        font-size: 18px;
        line-height: 19px;
        text-transform: uppercase;
        color: #e2262d;
      }

      .group-input {
        label {
          font-weight: bold;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.4);
        }
      }

      .label-requests-number {
        font-weight: 600;
        font-size: 15px;
        line-height: 20px;
        color: rgba(0, 0, 0, 0.5);
      }

      .label-requests-description {
        font-weight: 500;
        font-size: 12px;
        line-height: 20px;
        color: rgba(0, 0, 0, 0.8);
      }
    }
  }
</style>
